import { length, presence, regex, strictInt } from "@/app/validators/api/customValidations";
import { Country } from "@/app/utils/common/constants";

export const organisationRegistrationNumber = {
    [Country.FRA]: {
        presence: presence()
    },
    [Country.DEU]: {
        presence: presence()
    },
    [Country.GBR]: {
        presence: presence()
    },
    [Country.ESP]: {
        presence: presence()
    },
    [Country.NLD]: {
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    },
    [Country.ITA]: {
        presence: presence()
    },
    [Country.IRL]: {
        presence: presence()
    },
    [Country.AUT]: {
        presence: presence()
    },
    [Country.FIN]: {
        presence: presence()
    },
}

export const organisationTaxId = {
    [Country.DEU]: {
        presence: presence()
    },
    [Country.GBR]: {
        presence: presence()
    },
    [Country.USA]: {
        length: length(9,9), "strictInt": strictInt(), presence: presence()
    },
    [Country.NLD]: {
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    }
}

export const organisationVatNumber = {
    [Country.FRA]: {
        presence: presence()
    },
    [Country.DEU]: {
        presence: presence()
    },
    [Country.GBR]: {
        presence: presence()
    },
    [Country.ESP]: {
        presence: presence()
    },
    [Country.NLD]: {
        presence: presence()
    },
    [Country.ITA]: {
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    },
    [Country.IRL]: {
        presence: presence()
    },
    [Country.AUT]: {
        presence: presence()
    },
    [Country.FIN]: {
        presence: presence()
    }
}

export const soleProprietorRegistrationNumber = {
    [Country.FRA]: {
        presence: presence()
    },
    [Country.DEU]: {
        presence: presence()
    },
    [Country.GBR]: {
        presence: presence()
    },
    [Country.NLD]: {
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    },
    [Country.ITA]: {
        presence: presence()
    },
    [Country.IRL]: {
        presence: presence()
    },
    [Country.AUT]: {
        presence: presence()
    },
    [Country.FIN]: {
        presence: presence()
    }
}

export const soleProprietorTaxId = {
    [Country.USA]: {
        length: length(9,9), "strictInt": strictInt(), presence: presence()
    }
}

export const soleProprietorVatNumber = {
    [Country.GBR]: {
        regex: regex("^GB\\d{9,12}$", "start with GB followed by 9-12 digits"), presence: presence()
    },
    [Country.ITA]: {
        regex: regex("^IT\\d{11}$", "start with IT followed by 11 digits"), presence: presence()
    },
    [Country.IRL]: {
        regex: regex("^IE\\d{8,9}$", "start with IE followed by 8-9 digits"), presence: presence()
    },
    [Country.AUT]: {
        presence: presence()
    },
    [Country.FIN]: {
        regex: regex("^FI\\d{8}$", "start with FI followed by 8 digits"), presence: presence()
    }
}

export const accountNumber = {
    [Country.GBR]: {
        length: length(8,8), "strictInt": strictInt(), presence: presence()
    },
    [Country.USA]: {
        length: length(3,17), "strictInt": strictInt(), presence: presence()
    }
}

export const bankCode = {
    [Country.USA]: {
        length: length(9,10), "strictInt": strictInt(), presence: presence()
    }
}

export const iban = {
    [Country.FRA]: {
        // regex: regex("^FR[A-Za-z0-9]{25}$", "start with FR followed by 25 characters")
        presence: presence()
    },
    [Country.DEU]: {
        // regex: regex("^DE[A-Za-z0-9]{20}$", "start with DE followed by 20 characters")
        presence: presence()
    },
    [Country.ESP]: {
        // regex: regex("^ES[A-Za-z0-9]{22}$", "start with ES followed by 22 characters")
        presence: presence()
    },
    [Country.NLD]: {
        // regex: regex("^NL[A-Za-z0-9]{16}$", "start with ES followed by 22 characters")
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    },
    [Country.ITA]: {
        presence: presence()
    },
    [Country.IRL]: {
        presence: presence()
    },
    [Country.AUT]: {
        presence: presence()
    },
    [Country.FIN]: {
        presence: presence()
    }
}

export const sortCode = {
    [Country.GBR]: {
        length: length(6,6), "strictInt": strictInt(), presence: presence()
    }
}

export const accountType = {
    [Country.USA]: {
        presence: presence()
    }
}

export const beneficiaryTaxId = {
    [Country.USA]: {
        length: length(9,9), "strictInt": strictInt(), presence: presence()
    },
    [Country.GBR]: {
        presence: presence(),
        regex: regex(
            "^(\\d{10}|(?![Bb][Gg]|[Gg][Bb]|[Kk][Nn]|[Nn][Kk]|[Nn][Tt]|[Tt][Nn]|[Zz]{2})[ACEGHJ-PR-TW-Zaceghj-pr-tw-z][ACEGHJ-NPR-TW-Zaceghj-npr-tw-z]\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}\\s?[A-Da-d])$",
            "be a 10-digit UTR (e.g. 3194027616) or a NINO (e.g. AA123456C)"
        )
    },
    [Country.DEU]: {
        presence: presence()
    },
    [Country.FRA]: {
        presence: presence()
    },
    [Country.ESP]: {
        presence: presence()
    },
    [Country.NLD]: {
        presence: presence()
    },
    [Country.BEL]: {
        presence: presence()
    },
    [Country.ITA]: {
        presence: presence()
    },
    [Country.IRL]: {
        presence: presence()
    },

    [Country.AUT]: {
        presence: presence()
    },
    [Country.BGR]: {
        presence: presence()
    },
    [Country.HRV]: {
        presence: presence()
    },
    [Country.CYP]: {
        presence: presence()
    },
    [Country.CZE]: {
        presence: presence()
    },
    [Country.DNK]: {
        presence: presence()
    },
    [Country.FIN]: {
        presence: presence()
    },
    [Country.GRC]: {
        presence: presence()
    },
    [Country.HUN]: {
        presence: presence()
    },
    [Country.LVA]: {
        presence: presence()
    },
    [Country.LIE]: {
        presence: presence()
    },
    [Country.LTU]: {
        presence: presence()
    },
    [Country.LUX]: {
        presence: presence()
    },
    [Country.MLT]: {
        presence: presence()
    },
    [Country.NOR]: {
        presence: presence()
    },
    [Country.POL]: {
        presence: presence()
    },
    [Country.PRT]: {
        presence: presence()
    },
    [Country.ROU]: {
        presence: presence()
    },
    [Country.SVK]: {
        presence: presence()
    },
    [Country.SVN]: {
        presence: presence()
    },
    [Country.SWE]: {
        presence: presence()
    },

}
export const stateCode = {
    [Country.USA]: {
        presence: presence()
    },
    ["CAN"]: {
        presence: presence()
    },
    ["IND"]: {
        presence: presence()
    }
}